const BASE_URL = '/api/hotel';
const OWNER_ACTIONS_BASE_URL = '/api/v1/owner-actions';

export default {
    list(hotelId) {
        return axios.get(`${BASE_URL}/${hotelId}/unavailability-periods`);
    },

    create(hotelId, payload) {
        return axios.post(`${BASE_URL}/${hotelId}/unavailability-periods`, payload);
    },

    delete(hotelId, id) {
        return axios.delete(`${BASE_URL}/${hotelId}/unavailability-periods/${id}`);
    },

    checkConflicts(hotelId, startDate, endDate) {
        return axios.get(`${BASE_URL}/${hotelId}/unavailability-periods/check-conflicts`, {
            params: { start_date: startDate, end_date: endDate },
        });
    },

    listByOwnerToken(tokenHash) {
        return axios.get(`${OWNER_ACTIONS_BASE_URL}/${tokenHash}/unavailability-periods`);
    },

    checkConflictsByOwnerToken(tokenHash, startDate, endDate) {
        return axios.get(`${OWNER_ACTIONS_BASE_URL}/${tokenHash}/unavailability-periods/check-conflicts`, {
            params: { start_date: startDate, end_date: endDate },
        });
    },
};
